const videoInit = () => {
    const btnVideo = document.querySelectorAll('.js-play-video');
    btnVideo &&
        btnVideo.forEach((item) => {
            item.addEventListener('click', (e) => {
                const { target } = e;
                if (target instanceof HTMLElement) {
                    const container = target.closest('.js-video-container');
                    if (container instanceof HTMLElement) {
                        const img = container.querySelector('.js-video-placeholder');
                        if (img) {
                            const videoUrl = img.getAttribute('data-video-url');
                            if (!videoUrl)
                                return;
                            const iframe = document.createElement('iframe');
                            if (!iframe)
                                return;
                            iframe.setAttribute('src', `${videoUrl}?autoplay=1`);
                            iframe.setAttribute('frameborder', '0');
                            iframe.setAttribute('class', 'iframe');
                            container.innerHTML = '';
                            container.appendChild(iframe);
                            iframe.setAttribute('allow', 'autoplay');
                        }
                    }
                }
            });
        });
};
export default videoInit;
